// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0PkGg","label":"styles_label__M9ydN","select":"styles_select__RlNFq","error":"styles_error__7oVig"};